export class LocationValetStatus {
    static DISABLED = 0;
    static ENABLED = 1;
    static ENABLED_FORCED = 2;
}

Object.freeze(LocationValetStatus);